import React from "react";
import { Spinner } from "../../atoms/Spinner";
import { EmptyState } from "../../molecules/EmptyState";
import { ARCHITECTURE_UNREADABLE, useArchitecture } from "../../../hooks/useArchitecture";
import { getApiErrorMessage } from "../../../services/apiErrors";
import { GateState } from "./ArchitectureGate.styles";
import type { ArchitectureGateProps } from "./ArchitectureGate.types";

/** Renders the old or the current page by the tenant's `old_architecture`; never the old one on a guess. */
export const ArchitectureGate: React.FC<ArchitectureGateProps> = ({
  old,
  current,
  loadingLabel = "Loading…",
}) => {
  const architecture = useArchitecture();
  if (architecture.status === "loading") {
    return (
      <GateState role="status">
        <Spinner size={18} />
        {loadingLabel}
      </GateState>
    );
  }
  if (architecture.status === "error") {
    return (
      <EmptyState
        tone="error"
        title="This page couldn't load"
        caption={getApiErrorMessage(architecture.error, ARCHITECTURE_UNREADABLE)}
        action={{ label: "Try again", onClick: architecture.retry }}
        announce
      />
    );
  }
  return <>{architecture.oldArchitecture ? old : current}</>;
};

export default ArchitectureGate;
